import React, { useState } from 'react';
import Srcset from '@/components/common/Srcset';
import EditDetails from './edits/EditDetails';
import { useDispatch,useSelector} from "react-redux";
import { showPwaLoader } from "@/redux/actions/pwaAction";


const MyDetails = (props) => {
  const { styles, userDetails, activeTag, root } = props;
  // const [editPageState, setEditPageState] = useState(null);
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const backspan = <div className={`back ${styles.account_back}`} onClick={() => {
    if(props.editPageState) {
      props.activeTab('myDetailsTab')
    } else {
      props.activeTab('')
    }
    props.setEditPageState(null)
    }}>
        <span className={styles.arrow}>
          <Srcset
            requirePath={true}
            className={'back_icon'}
            svgFile={true}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0}
          />
        </span>
  </div>
  if (props.editPageState && props.editPageState != null && props.editPageState != '' && root == "my-details-edit") {
    return (
      <>
        <div className={`${styles.account_card} edit_details`}>
        {backspan}
        <div className={`${styles.card_head}`}>
          <div className={`${styles.card_title} x-large-xs xx-large-sm xx-large-md light`}>My details</div>
        </div>
          <div className="flex"><p className={`large-md large-sm large-xs light`}>{props.editPageState=='password'?"Change ":"Edit "}{props.editPageState}{props.editPageState=='email'?" address":""} </p> <span tabIndex={0} className="small-md small-sm small-xs hover" onClick={() => {props.activeTab('myDetailsTab');props.setEditPageState(null)}}>Cancel</span></div>
        </div>
         <EditDetails editPageState={props.editPageState} userDetails={userDetails} styles={styles} /> 
      </>
    )
  } else if(root == "my-details") {
  return (
    <div className={`${styles.account_card} my_account_card`}>
      <div className={`${styles.account_back}`}>
        <Srcset
          onClick={() => { props.activeTab('') }}
          requirePath={true}
          svgFile={true}
          className={'back_icon'}
          src={"images/Icons/Arrow/Right/large.svg"}
          alt="back span"
          height="16"
          width="19.11"
          tabIndex={0}
        />
        <Srcset
          onClick={() => { props.setAccountSidebarOpen(false); props.activeTab(''); }}
          requirePath={true}
          svgFile={true}
          className={'close_icon_account_tab'}
          src={"images/Icons/Cross/Large.svg"}
          alt="cloe span"
          height="16"
          width="19.11"
        />
      </div>
      <div className={`${styles.card_head}`}>
        <div className={`${styles.card_title} x-large-xs xx-large-sm xx-large-md light`}>My details</div>
      </div>
      <div className={`${styles.subtitle} normal-xs large-sm large-md medium-xs light-sm light-md`}>Account details</div>
      <div className={`${styles.card_body}`}>
        <div className={`${styles.details_list}`}>
          <div className={`${styles.detail_item}`}>
            <div className={`${styles.detail_label} small-xs normal-sm normal-md medium-sm medium-md`}>Full name &nbsp; &nbsp;<span tabIndex={0} className="small-md small-sm small-xs" onClick={() => {props.activeTab('myDetailsTabEdit');props.setEditPageState('name')}}>Edit</span></div>
            <div className={`${styles.detail_title} small`}>{userDetails?.firstName?.replace('N/A', '')} {userDetails?.lastName?.replace('N/A', '')}</div>
          </div>
          <div className={`${styles.divider}`}></div>
          <div className={`${styles.detail_item}`}>
            <div className={`${styles.detail_label} small-xs normal-sm normal-md medium-sm medium-md`}>Email &nbsp; &nbsp;<span tabIndex={0} className="small-md small-sm small-xs"  onClick={() => {props.activeTab('myDetailsTabEdit');props.setEditPageState('email')}}>Edit</span></div>
            <div className={`${styles.detail_title} small`}>{userDetails?.email}</div>
          </div>
          <div className={`${styles.divider}`}></div>
          <div className={`${styles.detail_item}`}>
            <div className={`${styles.detail_label} small-xs normal-sm normal-md medium-sm medium-md`}>Password &nbsp; &nbsp;<span tabIndex={0} className="small-md small-sm small-xs"  onClick={() => {props.activeTab('myDetailsTabEdit');props.setEditPageState('password')}}>Edit</span></div>
            <div className={`${styles.detail_title} small`}><span className="small-md small-sm small-xs pwd_txt_circle"><input type='password' value='12345678978' disabled /></span></div>
          </div>
          {/* <div className={`${styles.divider}`}></div> */}
        </div>
        {userDetails?.defaultAddress &&
          <>
            <div className={`${styles.details_list}`}>
              <div className={`${styles.divider}`}></div>


            </div>
            <div className={`${styles.user_addresses}`}>
              <div className={`${styles.subtitle} subtitle_two large light`}>Address book <span className="small-md small-sm small-xs"></span></div>
              <h6 className='medium-md medium-xs normal-md normal-sm normal-xs'>Default address</h6>
              <address className='small'>
                {userDetails?.defaultAddress?.name}
                {userDetails?.defaultAddress?.name && <br />}
                {userDetails?.defaultAddress?.address1}
                {userDetails?.defaultAddress?.address1 && <br />}
                {userDetails?.defaultAddress?.address2}
                {userDetails?.defaultAddress?.address2 && <br />}
                {userDetails?.defaultAddress?.city}
                {userDetails?.defaultAddress?.city && <br />}
                {userDetails?.defaultAddress?.country}, {userDetails?.defaultAddress?.province}
                {(userDetails?.defaultAddress?.country || userDetails?.defaultAddress?.province) && <br />}
                {userDetails?.defaultAddress?.zip}
              </address>
            </div>
          </>
        }
        {isPWA && <div className={`${styles.delete_acc} small`}>
                <a href="/delete-my-olivela-account" onClick={() => { dispatch(showPwaLoader(true)) }}>Delete account</a>
        </div>}
      </div>
    </div>
  )
      }
}

export default MyDetails